import { ViewModel as model } from './model';
import template from './template.html';

import { registerComponent } from '@/utils/engine/register-component';

registerComponent('fc-sortable', { model, template });
